import { Navigate, useTypedParams } from '@sorare/routing';
import { ANY_SPORT_SERIES_MY_CARDS_GALLERY_RARITY_SET_LEAGUE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import type { PageParams } from './__generated__/routeParams.ts';

const LeagueSlugPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { rarity, set, league } = useTypedParams<PageParams>();

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_SERIES_MY_CARDS_GALLERY_RARITY_SET_LEAGUE,
        {
          params: {
            rarity,
            set,
            league,
          },
        }
      )}
    />
  );
};
export default LeagueSlugPage;
